"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalClient = void 0;
const Client_1 = require("./api/resources/link/client/Client");
const Client_2 = require("./api/resources/profile/client/Client");
const Client_3 = require("./api/resources/devices/client/Client");
const Client_4 = require("./api/resources/activity/client/Client");
const Client_5 = require("./api/resources/workouts/client/Client");
const Client_6 = require("./api/resources/sleep/client/Client");
const Client_7 = require("./api/resources/body/client/Client");
const Client_8 = require("./api/resources/meal/client/Client");
const Client_9 = require("./api/resources/vitals/client/Client");
const Client_10 = require("./api/resources/user/client/Client");
const Client_11 = require("./api/resources/team/client/Client");
const Client_12 = require("./api/resources/providers/client/Client");
const Client_13 = require("./api/resources/introspect/client/Client");
const Client_14 = require("./api/resources/labTests/client/Client");
const Client_15 = require("./api/resources/testkit/client/Client");
const Client_16 = require("./api/resources/insurance/client/Client");
class VitalClient {
    constructor(_options) {
        this._options = _options;
    }
    get link() {
        var _a;
        return ((_a = this._link) !== null && _a !== void 0 ? _a : (this._link = new Client_1.Link(this._options)));
    }
    get profile() {
        var _a;
        return ((_a = this._profile) !== null && _a !== void 0 ? _a : (this._profile = new Client_2.Profile(this._options)));
    }
    get devices() {
        var _a;
        return ((_a = this._devices) !== null && _a !== void 0 ? _a : (this._devices = new Client_3.Devices(this._options)));
    }
    get activity() {
        var _a;
        return ((_a = this._activity) !== null && _a !== void 0 ? _a : (this._activity = new Client_4.Activity(this._options)));
    }
    get workouts() {
        var _a;
        return ((_a = this._workouts) !== null && _a !== void 0 ? _a : (this._workouts = new Client_5.Workouts(this._options)));
    }
    get sleep() {
        var _a;
        return ((_a = this._sleep) !== null && _a !== void 0 ? _a : (this._sleep = new Client_6.Sleep(this._options)));
    }
    get body() {
        var _a;
        return ((_a = this._body) !== null && _a !== void 0 ? _a : (this._body = new Client_7.Body(this._options)));
    }
    get meal() {
        var _a;
        return ((_a = this._meal) !== null && _a !== void 0 ? _a : (this._meal = new Client_8.Meal(this._options)));
    }
    get vitals() {
        var _a;
        return ((_a = this._vitals) !== null && _a !== void 0 ? _a : (this._vitals = new Client_9.Vitals(this._options)));
    }
    get user() {
        var _a;
        return ((_a = this._user) !== null && _a !== void 0 ? _a : (this._user = new Client_10.User(this._options)));
    }
    get team() {
        var _a;
        return ((_a = this._team) !== null && _a !== void 0 ? _a : (this._team = new Client_11.Team(this._options)));
    }
    get providers() {
        var _a;
        return ((_a = this._providers) !== null && _a !== void 0 ? _a : (this._providers = new Client_12.Providers(this._options)));
    }
    get introspect() {
        var _a;
        return ((_a = this._introspect) !== null && _a !== void 0 ? _a : (this._introspect = new Client_13.Introspect(this._options)));
    }
    get labTests() {
        var _a;
        return ((_a = this._labTests) !== null && _a !== void 0 ? _a : (this._labTests = new Client_14.LabTests(this._options)));
    }
    get testkit() {
        var _a;
        return ((_a = this._testkit) !== null && _a !== void 0 ? _a : (this._testkit = new Client_15.Testkit(this._options)));
    }
    get insurance() {
        var _a;
        return ((_a = this._insurance) !== null && _a !== void 0 ? _a : (this._insurance = new Client_16.Insurance(this._options)));
    }
}
exports.VitalClient = VitalClient;
